@use "~theme/typography";
@use "~theme/breakpoints";

.content {
  padding: 24px 24px 0;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.contentNew {
  padding: 24px 24px 0;
  background:white;

  @include breakpoints.desktop {
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.addressFieldGroup {
  @include breakpoints.mobile-large {
    display: grid;
    grid-gap: 0 16px;
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
}

.alwaysVisible {
  display: inherit;
}

.field {
  margin: 0 0 16px;
}

.apt {
  margin: 3px 0 16px;
}

.fieldSpan {
  grid-column: 1 / span 2;
}

.buttonGroup {
  margin: 12px 0 16px;
}

.radioButton {
  margin-bottom: 16px;
}

.emptyError {
  display: none;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin-bottom: 24px;

  @include breakpoints.desktop {
    margin: {
      top: 0;
      bottom: 24px;
    }
  }
}
